<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">哨兵节点</a></p>
          <!-- <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2"></a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">哨兵节点</div>
      <div class="p3">验证节点需要确保网络能够承受分布式拒绝服务 (DDoS) 攻击。</div>
      <div class="p3">减轻此类风险的推荐方法是使用 Sentry 节点构建可以保护验证节点的网络拓扑。</div>
      <div class="p3">验证节点只能连接到他们信任的完整节点，例如自己维护的完整节点或社区中已知的其他验证者运行的节点。验证节点通常在数据中心运行。大多数数据中心提供直接连接到云服务提供商的网络。验证节点可以通过这样的网络连接到云上的哨兵节点。这将 DDoS 攻击的负担直接从验证节点转移到其 Sentry 节点，并且可能需要在必要时启动或激活新的 Sentry 节点以减少此类攻击的影响。</div>
      <div class="p3">Sentry 节点可以快速启动或更改其 IP 地址。由于验证节点和哨兵节点之间的链路在私有IP网络中，黑客无法通过网络直接攻击验证节点。这将确保区块提议和验证节点的投票将始终由Sentry 节点正常广播。</div>
      <div class="p3">要配置 Sentry 节点架构，您可以按照以下说明进行操作：</div>
      <div class="p3">验证节点应该编辑他们的 config.toml：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">＃ Comma separated list of nodes to keep persistent connections</div>
          <div style="padding:5px 0">＃ Do not add private peers to this list if you do not want them advertised</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">persistent_peers = [list of sentry nodes]</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">＃ Set true to enable the peer-exchange reactor</div>
          <div style="padding:5px 0">pex = false</div>
        </div>
      </div>
      <div class="p3">Sentry 节点应该编辑它们的 config.toml：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">＃ comma separated list of peer IDs to keep private (will not be gossiped to other peers)</div>
          <div style="padding:5px 0">＃ Example ID: 3e16af0cead27979e1fc3dac57d03df3c7a77acc</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">private_peer_ids = "node_ids_of_private_peers"</div>
        </div>
      </div>
      <div class="p3">参考文档： <a href="https://forum.cosmos.network/t/sentry-node-architecture-overview/454">https://forum.cosmos.network/t/sentry-node-architecture-overview/454</a> </div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">哨兵节点</a></p>
      <!-- <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2"></a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sentryNode',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>